<!--
 * @Author: Yuan Cong <email: wso2848303@163.com> <tel: 15821618224>
 * @Date: 2021-01-06 16:15:22
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-01-19 11:53:08
 * @Description: 关闭按钮
 * @FilePath: /src/components/icons/Close/index.vue
-->
<template>
  <div class="icon-close" :class="computedClass" :style="componentStyle" @click="handleClick">
    <div class="close-before" :style="contentStyle"></div>
    <div class="close-after" :style="contentStyle"></div>
  </div>
</template>
<script>
/**
 * 关闭按钮
 * @module Close
 */
export default {
  name: 'Close',
  /**
   * @prop {String} className 外部class
   * @prop {String} color 按钮颜色 默认#7C7D80
   * @prop {String} width 按钮大小 默认24px
   * @prop {String} weight 粗细 默认2px
   * @prop {String} id 自定义参数
   */
  props: {
    className: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: '#7C7D80'
    },
    width: {
      type: String,
      default: '24px'
    },
    id: {
      defalut: ''
    },
    weight: {
      type: String,
      default: '2px'
    }
  },
  /**
   * @prop {Object} computedClass 计算后的class
   * @prop {Object} computedStyle 组件样式
   * @prop {Object} contentStyle 横线样式
   */
  computed: {
    computedClass() {
      let ret = {};
      ret[this.className] = true;
      return ret;
    },
    componentStyle() {
      let ret = {};
      ret.width = ret.height = this.width;
      return ret;
    },
    contentStyle() {
      let ret = {};
      ret.backgroundColor = this.color;
      ret.height = this.weight;
      return ret;
    }
  },
  methods: {
    /**
     * @event click 暴漏点击事件
     */
    /**
     * @description 点击事件
     * @function handleClick
     */
    handleClick: function() {
      this.$emit('click', this.id);
    }
  }
};
</script>
<style lang="less" scoped>
.icon-close {
  position: relative;
  cursor: pointer;
  .close-before {
    position: absolute;
    width: 100%;
    top: 50%;
    left: 0;
    margin-top: -1px;
    transform: rotate(45deg);
  }
  .close-after {
    position: absolute;
    width: 100%;
    top: 50%;
    left: 0;
    margin-top: -1px;
    transform: rotate(-45deg);
  }
}
</style>
